export enum FontStyle {
  h1 = 'heading1',
  h2 = 'heading2',
  h3 = 'heading3',
  h4 = 'heading4',
  h5 = 'heading5',
  h6 = 'heading6',
}
